export default __webpack_public_path__ + "static/media/ok.globe.white.2098dbe4.png";